import { GoogleCircleFilled, MailFilled, PhoneFilled } from "@ant-design/icons";
import { message } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { convertToPrescriptionArray } from "modules/utilities/utility";
import trayaLogo from "../../../assets/img/prescription_assets/Traya_Logo.jpg";
import Footer1 from "../../../assets/img/prescription_assets/dr_harish_balaji.png";
import Footer2 from "../../../assets/img/prescription_assets/dr_aakansha_gupta.png";
import Footer3 from "../../../assets/img/prescription_assets/dr_siddhi_sonawane.png";
import Footer4 from "../../../assets/img/prescription_assets/dr_kalyani_deshmukh.png";
import Footer5 from "../../../assets/img/prescription_assets/dr_shefali_saini.png";
import Footer6 from "../../../assets/img/prescription_assets/dr_dhwani_saxena.png";
import Footer8 from "../../../assets/img/prescription_assets/dr_shailendra_chaubey.png";
import phoneIcon from "../../../assets/img/prescription_assets/phone_icon.png";

export default function InternationalPrescription({ dataObj, setIsPrint }) {
	const [startDownload, setStartDownload] = useState(false);
	let data = [];
	if (dataObj) {
		data.push(dataObj);
	}
	const printContentRef = useRef(null);
	useEffect(() => {
		const downloadPDF = async () => {
			const printContent = printContentRef.current;
			if (printContent) {
				// Check if printContent is not null or undefined
				const canvas = await html2canvas(printContent);
				const imgData = canvas.toDataURL("image/png");
				const pdf = new jsPDF({
					orientation: "portrait",
					unit: "mm",
					format: "a4",
				});
				pdf.addImage(imgData, "PNG", 10, 10, 190, 280);
				pdf.save(
					`${dataObj?.customer?.first_name}_${dataObj?.order?.order_display_id}`
				);
			}
		};

		if (startDownload) {
			setIsPrint(false);
			downloadPDF();
		}
	}, [startDownload, setIsPrint]);

	useEffect(() => {
		setStartDownload(true);
	}, []);


	let doctor = dataObj?.order?.doctor;
	let FooterImageMain = false;
	let FooterImageSec = false;
	// Step 1: Data Structuring for Doctor-Footer mapping
	const doctorFooterMap = {
		"Dr Harish Balaji": Footer1,
		"Dr Aakanksha Gupta": Footer2,
		"Dr Siddhi Sonawane": Footer3,
		"Dr Kalyani Deshmukh": Footer4,
		"Dr Shefali Saini": Footer5,
		"Dr Dhwani Saxena": Footer6,
		"Dr Shailendra": Footer8,
	};

	// Step 2: Check doctor conditions
	if (doctor?.length > 0) {
		const doctorName = doctor[doctor.length -1]?.user.first_name;
		// Step 3: Check doctor name in the mapping
		if (doctorName && doctorFooterMap.hasOwnProperty(doctorName)) {
			FooterImageMain = doctorFooterMap[doctorName];
		} else {
			// Step 4: Set default FooterImageMain value (if needed)
			FooterImageMain = Footer4; // Default

			// Step 5: Check prescriptions for ayurveda and allopathy types
			let hasAyurveda = false;
			let hasAllopathy = false;

			for (const prescription of dataObj?.prescription || []) {
				if (prescription?.type === "ayurveda") {
					hasAyurveda = true;
				} else if (prescription?.type === "allopathy") {
					hasAllopathy = true;
				}
			}

			// Set Footer images after the loop is completed
			if (hasAyurveda) {
				FooterImageSec = true;
			}

			if (hasAllopathy) {
				FooterImageMain = Footer4;
			}
		}
	} else {
		let doctorName = dataObj?.doctorData?.firstName;
		if (doctorName && doctorFooterMap.hasOwnProperty(doctorName)) {
			FooterImageMain = doctorFooterMap[doctorName];
		} else {
			// Step 6: Handle case where doctor array is empty
			// Check prescriptions for ayurveda and allopathy types
			let hasAyurveda = false;
			let hasAllopathy = false;

			for (const prescription of dataObj?.prescription || []) {
				if (prescription?.type === "ayurveda") {
					hasAyurveda = true;
				} else if (prescription?.type === "allopathy") {
					hasAllopathy = true;
				}
			}

			// Set Footer images after the loop is completed
			if (hasAyurveda) {
				FooterImageSec = true;
			}

			if (hasAllopathy) {
				FooterImageMain = Footer4;
			}
			// Step 7: Handle case where neither ayurveda nor allopathy types are found
			if (!FooterImageMain && !FooterImageSec) {
				message.info("Prescription Details not found");
			}
		}
	}

	return (
		<div
			ref={printContentRef}
			id="printContent"
			style={{
				visibility: false,
				width: "210mm", // A4 width
				minHeight: "297mm", // A4 height
				padding: "20px", // Add padding for spacing
				boxSizing: "border-box", // Include padding in the total dimensions
				fontFamily: "Nunito Sans, sans-serif",
				fontSize: "10px",
			}}>
			{data.length > 0
				? data.map((data, index) => {
						const prescription = data?.prescription;
						let prescriptionData = [];
						let printData = [];
						let recommendedPrescriptionData = [];

						prescription.map(prescription => {
							if (prescription.version === 1) {
								const prescriptionList = prescription.prescription;
								prescriptionData.push(prescriptionList);
							} else {
								const prescriptionList =
									convertToPrescriptionArray(prescription);
								prescriptionList.map(prescriptionList => {
									if (prescriptionList.showRecommendation === false) {
										printData.push(prescriptionList);
									} else {
										recommendedPrescriptionData.push(prescriptionList);
									}
								});
								return (prescriptionData = [
									...printData,
									...recommendedPrescriptionData,
								]);
							}
						});

						let countTotal = 0;
						let notBreak = true;
						const prescriptionLength = prescriptionData.length;

						return (
							<div style={{ visibility: false }}>
								<div
									id={`ddtt-${index}`}
									style={{
										pageBreakAfter: "always",
									}}>
									<div>
										<div
											style={{
												display: "flex",
												justifyContent: "space-evenly",
											}}>
											<div
												className="logo"
												style={{
													width: "200px",
													height: "100px",
													position: "relative",
												}}>
												<img
													src={trayaLogo}
													alt=""
													style={{
														width: "100%",
														height: "75%",
														objectFit: "cover",
													}}
												/>
											</div>
											<div style={{ paddingLeft: "4%" }}>
												<div
													style={{
														fontFamily: "Nunito Sans, sans-serif",
														color: "black",

														textAlign: "center",
													}}>
													<span style={{ fontSize: "25px" }}>
														Tatvartha Health Pvt. Ltd.
													</span>
												</div>
												<div
													style={{
														fontFamily: "Nunito Sans, sans-serif",
														color: "black",

														textAlign: "center",
													}}>
													<span style={{ fontSize: "15px" }}>
														1st Floor, B101 Interface 16 Mindspace Malad West
														Mumbai, MH-400064
													</span>
												</div>
											</div>
										</div>
										<div
											style={{
												display: "flex",
												justifyContent: "space-between",
											}}
										> 
										<div
											style={{
												fontFamily: "Nunito Sans, sans-serif",
												color: "black",
												// textAlign: "right",
											}}>
											<span style={{ fontSize: "14px" }}>
												{data?.order?.order_display_id}
											</span>
											<hr
												style={{
													// textAlign: "right",
													// width: "200px",
													// marginRight: 0,
												}}
											/>
										</div>
										<div
											style={{
												fontFamily: "Nunito Sans, sans-serif",
												color: "black",
												textAlign: "right",
											}}>
											<span style={{ fontSize: "14px" }}>
												{data?.customer?.first_name}
											</span>
											<hr
												style={{
													// textAlign: "right",
													// width: "200px",
													// marginRight: 0,
												}}
											/>
										</div>
										<div
											style={{
												marginBottom: "20px",
												fontFamily: "Nunito Sans, sans-serif",
												color: "black",
												// textAlign: "right",
											}}>
											<span style={{ fontSize: "14px" }}>
											{moment(data?.order?.created_at).format("DD-MMM-YYYY")}
											</span>
											<hr
												style={{
													// textAlign: "right",
													// width: "200px",
													// marginRight: 0,`
												}}
											/>
										</div>
										</div>
									</div>
									{prescriptionData.map((data, i) => {
										const quantity = data?.quantity;

										countTotal++;
										let breakPage = false;

										if (countTotal > 6) {
											breakPage = true;
											countTotal = 0;
										}

										let isRecommended = "";

										if (data?.showRecommendation === true) {
											isRecommended = "RECOMMENDED BY DOCTOR";
										}

										if (typeof data !== "string") {
											let isComposition = false;
											if (data?.is_composition === true) {
												isComposition = true;
											}

											if (prescriptionLength === i + 1) {
												if (prescriptionLength % 7 === 0) {
													notBreak = false;
												}
											}

											return (
												<>
													<div>
														{isComposition ? (
															<>
																<p
																	style={{
																		fontSize: "14px",
																		fontFamily: "Nunito Sans, sans-serif",

																		fontWeight: "bold",
																		color: "#58595b",
																		margin: 0,
																		display: "flex",
																	}}>
																	<span
																		style={{ flex: "1", marginRight: "8px" }}>
																		{data?.display_name}{" "}
																		<span
																			style={{
																				color: "black",

																				fontSize: "14px",
																				fontWeight: "0px",
																			}}>
																			X {data?.composition}{" "}
																			{!isRecommended && (
																				<> x {quantity ? quantity : 1}</>
																			)}
																		</span>
																	</span>
																	<span
																		style={{
																			flex: "1",
																			marginLeft: "8px",
																			textAlign: "right",
																			float: "right",
																		}}>
																		<span>{data?.dosage}</span>{" "}
																		{isRecommended && (
																			<span style={{ float: "right" }}>
																				({isRecommended})
																			</span>
																		)}
																	</span>
																</p>
															</>
														) : (
															<p
																style={{
																	fontSize: "14px",
																	fontFamily: "Nunito Sans, sans-serif",

																	fontWeight: "bold",
																	color: "#58595b",
																	margin: 0,
																	display: "flex",
																	justifyContent: "space-between",
																}}>
																<span>
																	{data?.display_name}{" "}
																	<span
																		style={{
																			color: "black",
																			fontSize: "12px",
																			fontWeight: "0px",
																		}}>
																		{!isRecommended && (
																			<> x {quantity ? quantity : 1}</>
																		)}
																	</span>
																</span>
																<span style={{ float: "right" }}>
																	<span>{data?.dosage}</span>
																	{isRecommended && (
																		<span style={{ float: "right" }}>
																			{" "}
																			({isRecommended})
																		</span>
																	)}
																</span>
															</p>
														)}
														<p
															style={{
																color: "black",

																fontSize: "14px",
																marginTop: "12px",
																display: "flex",
																justifyContent: "space-between",
																gap:"20px"
															}}>
															<span style={{flex:"1", textAlign:"left"}}>{data?.description}</span>
															<span style={{ flex:"1", textAlign:"right" }}>
																{data?.info}
															</span>
														</p>
														<hr />
														{breakPage && notBreak && (
															<>
																<div
																	style={{
																		pageBreakBefore: "always",
																		paddingTop: "80px",
																	}}
																/>
															</>
														)}
													</div>
												</>
											);
										} else {
											return (
												<>
													<p style={{ color: "black", letterSpacing: "0.3px" }}>
														{data}
													</p>
													<hr style={{ border: "0.5px solid black" }} />
												</>
											);
										}
									})}
									<br />
									<br />
								</div>
							</div>
						);
				  })
				: []}
			<div
				style={{
					justifyContent: "space-between",
					display: "flex",
				}}>
				{FooterImageMain ? (
					<div>
						<img
							src={FooterImageMain}
							style={{
								objectFit: "contain",
							}}
							alt="Doctor Signature"
						/>
					</div>
				) : (
					<></>
				)}

					<div
						style={{
							justifyContent: "space-between",
							display: "flex",
						}}>
						<img
							src={Footer8}
							style={{
								objectFit: "contain",
							}}
							alt="Doctor Signature"
						/>
					</div>

			</div>
			<div>
				<br />
				<br />
				<div
					style={{
						fontFamily: "Nunito Sans, sans-serif",
						color: "black",
						textAlign: "right",
					}}>
					<span style={{ fontSize: "20px" }}>www.traya.health</span>{" "}
					<GoogleCircleFilled style={{ fontSize: "20px" }} />
				</div>
				<div
					style={{
						fontFamily: "Nunito Sans, sans-serif",
						color: "black",
						textAlign: "right",
					}}>
					<span style={{ fontSize: "20px" }}>hairexpert@traya.health</span>{" "}
					<MailFilled style={{ fontSize: "20px" }} />
				</div>
				<div
					style={{
						fontFamily: "Nunito Sans, sans-serif",
						color: "black",
						textAlign: "right",
					}}>
					<span style={{ fontSize: "20px" }}>+918828006272</span>{" "}
					{/* <PhoneFilled style={{ fontSize: "15px" }} /> */}
					<img src={phoneIcon} alt="" style={{width:"4%", paddingLeft:"1%"}}/>
				</div>
			</div>
		</div>
	);
}
